import { render, staticRenderFns } from "./WealthTransaction.vue?vue&type=template&id=897744aa&scoped=true"
import script from "./WealthTransaction.vue?vue&type=script&lang=ts"
export * from "./WealthTransaction.vue?vue&type=script&lang=ts"
import style0 from "./WealthTransaction.vue?vue&type=style&index=0&id=897744aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "897744aa",
  null
  
)

export default component.exports